import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import TEAM_PROP_TYPES from '../../lib/prop-types/team';
import LOADING_ERROR_PROP_TYPES from '../../lib/prop-types/loading-error';
import { SEASONS_PROP_TYPES, SEASON_PROP_TYPES } from '../../lib/prop-types/season';
import NoBackground from '../../components/club-frame/header/no-background';
import SeoHead from '../../components/seo';
import MatchReports from '../../components/team/reports';
import ClubRouter from '../../lib/routing';
import withTeam from '../../lib/with-team';
import { selectSeasonAction } from '../../store/clubs/actions';
import { getCurrentClubSeasons, getActiveSeasonId, getSeason } from '../../store/clubs/selectors';
import { fetchMatchReportsPageData } from '../../store/teams/match-reports/actions';
import {
  isLoading,
  hasLoaded,
  getReports,
  getLoadingError,
} from '../../store/teams/match-reports/selectors';

class TeamReportsPage extends React.Component {
  static async getInitialProps({ reduxStore, club, isServer, team, req, res, query }) {
    const initialProps = {
      activeSubSection: 'reports',
      pageType: 'team.reports',
      seasonId: query.season
        ? parseInt(query.season, 10)
        : getActiveSeasonId(reduxStore.getState()),
    };

    if (!isServer) {
      return initialProps;
    }

    const { error } = await reduxStore.dispatch(fetchMatchReportsPageData(club.id, team.id, req));

    if (error && error.errorStatusCode && res) {
      res.statusCode = error.errorStatusCode;
    }

    return initialProps;
  }

  componentDidMount() {
    const {
      loading,
      previouslyLoaded,
      loadPageData,
      club: { id: clubId },
      team: { id: teamId },
    } = this.props;
    if (!loading && !previouslyLoaded) {
      loadPageData(clubId, teamId);
    }
  }

  onSeasonFilterChangeHandler = (event) => {
    const seasonId = parseInt(event.target.value, 10);
    const {
      club,
      team: { id: teamId },
      selectSeason,
    } = this.props;

    selectSeason(seasonId);
    ClubRouter.pushClubRoute(club, 'team.reports', { teamId, season: seasonId });
  };

  render() {
    const { loading, loadingError, club, team, reports, seasons, season, seasonId } = this.props;

    return (
      <>
        <SeoHead
          club={club}
          descriptionTranslationKey="teams:reports_meta_description"
          route="team.reports"
          routeParams={{ teamId: team.id, seasonId }}
          titleTranslationKey="teams:reports_page_title"
          translationValues={{ teamName: team.name, seasonName: season && season.name }}
        />
        <NoBackground />
        <MatchReports
          isLoading={loading}
          loadingError={loadingError}
          club={club}
          reports={reports}
          onSeasonFilterChange={this.onSeasonFilterChangeHandler}
          seasons={seasons}
          seasonId={seasonId}
        />
      </>
    );
  }
}

TeamReportsPage.defaultProps = {
  season: null,
  loadingError: null,
  seasonId: null,
};

TeamReportsPage.propTypes = {
  loading: PropTypes.bool.isRequired,
  previouslyLoaded: PropTypes.bool.isRequired,
  loadingError: LOADING_ERROR_PROP_TYPES,
  loadPageData: PropTypes.func.isRequired,
  club: CLUB_PROP_TYPES.isRequired,
  team: TEAM_PROP_TYPES.isRequired,
  reports: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  seasons: SEASONS_PROP_TYPES.isRequired,
  season: SEASON_PROP_TYPES,
  seasonId: PropTypes.number,
  selectSeason: PropTypes.func.isRequired,
};

const dispatchToProps = {
  loadPageData: fetchMatchReportsPageData,
  selectSeason: selectSeasonAction,
};

const mapStateToProps = (state, { seasonId, teamId }) => ({
  loading: isLoading(state, teamId),
  previouslyLoaded: hasLoaded(state, teamId),
  loadingError: getLoadingError(state, teamId),
  reports: getReports(state, teamId, seasonId),
  seasons: getCurrentClubSeasons(state),
  season: getSeason(state, seasonId),
});

export default withTeam(connect(mapStateToProps, dispatchToProps)(TeamReportsPage));
